import Image from 'next/image'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import ContentAnonymous from '../content-anonymous/ContentAnonymous'
import TooltipAnonymous from '../content-anonymous/TooltipAnonymous'
import { CompanyInformationClientRequestFragment } from '../../../../../lib/graphql'
import { Icon } from '../../../../atoms'

const Contact = ({
  clientRequest,
}: {
  clientRequest: CompanyInformationClientRequestFragment
}) => {
  return (
    <div>
      <h3 className='mb-4 flex items-center gap-[6px] text-grey-700'>
        <FormattedMessage id='ui.Contact.title' defaultMessage='Client' />{' '}
        {!clientRequest.company?.name && <TooltipAnonymous />}
      </h3>
      <div className='flex items-center gap-5'>
        {clientRequest.company?.logoURL ? (
          <div>
            <Image
              src={
                clientRequest.company?.logoURL ?? '/images/placeholder-logo.png'
              }
              alt='logo'
              width={40}
              height={40}
              className='rounded-full object-cover shadow-md'
            />
          </div>
        ) : (
          <div className='flex h-10 w-10 items-center justify-center rounded-full bg-grey-300'>
            <Icon name='people' size={15} opacity={0.25} />
          </div>
        )}

        <div className='flex flex-col'>
          <div>
            {clientRequest.contact ? (
              `${clientRequest.contact.firstname && `${clientRequest.contact.firstname} `}${clientRequest.contact.lastname ?? ''}`
            ) : (
              <ContentAnonymous content='****** ******' />
            )}
          </div>
          <div className='flex gap-[5px] text-grey-700'>
            <FormattedMessage
              id='ui.Contact.companyName'
              defaultMessage='Entreprise :'
            />{' '}
            {clientRequest.company?.name ? (
              `${clientRequest.company?.name}`
            ) : (
              <ContentAnonymous content='******' />
            )}
          </div>
          <div className='flex gap-[5px] text-grey-700'>
            <FormattedMessage
              id='ui.Contact.contactMail'
              defaultMessage='Mail :'
            />{' '}
            {clientRequest.contact?.mail ? (
              `${clientRequest.contact?.mail}`
            ) : (
              <ContentAnonymous content='******' />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
